import { createSlice } from "@reduxjs/toolkit";
import utils from '../../Common/utils';



export const initialState = {
  data: {},
  hidden: [],  // blacklist
  shown: [],   // whitelist
};


const filtersSlice = createSlice({
  name: "filters",
  initialState: {
    data: {},
    hidden: [],
    shown: [],
    disabled: [],
    initial: {},
    masterSearch: false, // whether the unified "master search" UI is offered on this page
    searchPending: false, // true while a debounced search is typed but not yet applied
  },
  reducers: {
    _updateFilterData(state, action) {
      Object.assign(state.data, action.payload);
      utils.setURLFromObject(state.data);
    },
    _setSearchPending(state, action) {
      state.searchPending = action.payload;
    },
    _setFilterData(state, action) {
      state.data = { ...action.payload };
      utils.setURLFromObject(state.data);
    },
    _setBackToInitialFilterData(state) {
      // Clone so a later Object.assign on state.data can't mutate the stored
      // defaults (which would make filters "stick" across repeated clears).
      state.data = { ...state.initial };
      utils.setURLFromObject(state.data);
    },
    _hideFilters(state, action) {
      state.hidden = action.payload;
    },
    _setInitialFilterConf(state, action) {
      if (!('data' in action.payload)){
        console.error('Not data attr in _setInitialFilterConf payload!')
      }
      const { data, hidden = [], shown = [], disabled = [], masterSearch = false } = action.payload;

      state.initial = data;
      state.masterSearch = masterSearch;

      // If nothing is set in the URL, then set initial as current filterdata
      const curFiltersObj = utils.getObjectFromURL();
      if (Object.keys(curFiltersObj).length == 0){
        state.data = { ...state.initial };
      }

      // OLD implementation from before. Wrong...
      // for (const [initialKey, initialValue] of Object.entries(state.initial)) {
      //   // console.log('CUR', initialKey, curFiltersObj[initialKey], curFiltersObj)
      //   if (curFiltersObj[initialKey] === undefined) {
      //     state.data[initialKey] = initialValue;
      //     console.log('Setting initial filter', initialKey, initialValue);
      //   }
      // }
      // utils.setURLFromObject(state.data);

      state.hidden = hidden
      state.shown = shown
      state.disabled = disabled
    },
    setHidden(state, action) {
      state.hidden = action.payload;
    },
    setShown(state, action) {
      state.shown = action.payload;
    },
  },
});


export const {
  _updateFilterData,
  _setFilterData,
  _setBackToInitialFilterData,
  _setSearchPending,
  _hideFilters,
  _setInitialFilterConf,
  _setFiltersBarExpanded,
  setHidden,
  setShown,
} = filtersSlice.actions;

export default filtersSlice.reducer;
